import React, { FC } from 'react';
import { WhatsNewLinkType } from 'modules/configuration/enums/configuration.enum';

import './LinkCellRenderer.scss';

type LinkCellRendererProps = {
    data: any;
    onLinkClick?: (data: any) => void;
};

const getLinkValue = (type: WhatsNewLinkType) => {
    switch (type) {
        case WhatsNewLinkType.ArticleLink:
        case WhatsNewLinkType.ApplicationLink:
            return 'View link';
        case WhatsNewLinkType.Video:
            return 'Video';
        case WhatsNewLinkType.Image:
            return 'Image';
        case WhatsNewLinkType.Indicator:
            return 'Indicator';
    }
};
const LinkCellRenderer: FC<LinkCellRendererProps> = ({ data, onLinkClick }: LinkCellRendererProps) => {
    return (
        <div className="link-cell">
            <a onClick={() => onLinkClick?.(data)}>{getLinkValue(data.whatsNewTypeId)}</a>
        </div>
    );
};

export default LinkCellRenderer;
